import { Component, Input, OnInit } from '@angular/core';
import { ILinkUser } from '../../../classes/link-user';
import { BaseComponent } from '../../../../globals/classes/base.component';
import { UserData } from '../../../../globals/classes/userData';
import { delay } from 'rxjs/operators';
import { AppSettings } from '../../../app.settings';

@Component({
	selector: 'user-confirmation',
	template: require('./user-confirmation.component.html'),
})
export class UserConfirmationComponent extends BaseComponent implements OnInit {
	@Input() hasListInfo: boolean;
	public isGroupUserIdsBigModalEnabled: boolean = AppSettings.isGroupUserIdsBigModalEnabled;

	linkUserInfo: ILinkUser;

	ngOnInit(): void {
		this.mortalize(UserData.data$)
			.pipe(delay(0))
			.subscribe(
				(userData) =>
					!!userData &&
					(this.linkUserInfo = {
						userId: userData.userId,
						company: userData.company,
					})
			);
	}
}
